module.exports = __webpack_public_path__ + "static/img/00343r.2b23726.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/Images/00343r.jpg
// module id = aFBQ
// module chunks = 1